/// <amd-module name="SearchUI/Components/Callout/Callout" />
import * as React from "react";
import { Callout } from "VSSUI/Callout";
import { css } from "VSSUI/Util";
import { Location } from "VSSUI/Utilities/Position";
import { ICalloutComponentProps } from "SearchUI/Components/Callout/Callout.Props";

import "VSS/LoaderPlugins/Css!SearchUI/Components/Callout/Callout";

/**
 * Stateless component to render the VSSUI callout bubble attached to a DOM element given by
 * props.targetElement.
 * @param props
 */
export const CalloutComponent: React.StatelessComponent<ICalloutComponentProps> = (props: ICalloutComponentProps) => {
    return (
        <Callout
            anchorElement={props.targetElement}
            anchorOffset={{ horizontal: 0, vertical: 5 }}
            anchorOrigin={{ horizontal: Location.center, vertical: Location.end }}
            calloutOrigin={{ horizontal: Location.center, vertical: Location.start }}
            className={css("search-Callout")}
            contentShadow={true}
            role="tooltip"
        >
            <div id={props.id}>
                <div className={css("search-Callout-header")}>
                    <p className={css("search-Callout-title")}>{props.title}</p>
                </div>
                <div className={css("search-Callout-inner")}>
                    <div className={css("search-Callout-content")}>
                        <p className={css("search-Callout-subText")}>{props.content}</p>
                    </div>
                </div>
            </div>
        </Callout>
    );
};
